import { CollapsibleSection } from "../CollapsibleSection";

interface DevotionalTextProps {
  reference: string;
  content: string;
  id?: string;
}

export const DevotionalText = ({ reference, content, id }: DevotionalTextProps) => {
  return (
    <CollapsibleSection title="Text" id={id}>
      <p className="text-sage-600 font-medium mb-2 text-center font-serif text-lg">
        {reference}
      </p>
      <p className="font-serif text-lg leading-relaxed text-center text-justify italic">
        {content}
      </p>
    </CollapsibleSection>
  );
};